import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms'
import {GetFormsService} from '../../shared/services/get-forms.service';

@Injectable({
  providedIn: 'root'
})
export class GetCompanyFormsService {

  constructor(private fb: FormBuilder , private getFormsService: GetFormsService) {
  }



  getFilterCompanies(): FormGroup {
    return this.fb.group({
      name: [],
      clientName: [],
      city: [],
      address: [],
      countryCode: this.fb.group({ code: [null], name: [null] }),
      zip: [],
      code: [],
      client: [],
      office: this.fb.group({ id: [null], name: [null] }),
      created: [],
      uuid: [],
      sapCode: [],
      salesforceIdentifier: [],
      comment: [],
      blocked: this.fb.group({ id: [null], name: [null] }),
      active:  this.fb.group({ id: [null], name: [null] }),
      // vat: [],
    });
  }
  getInvoicesGeneration(): FormGroup {
    return this.fb.group({
      startDate: [null, Validators.required],
      endDate: [],
      isGroupSites: [],
      recurrence: this.fb.group({ id: [null, Validators.required], name: [null] }),
    });
  }

  getFilterSubscription(): FormGroup {
    return this.fb.group({
      subscriptionName: [],
      status: this.fb.group({ id: [null], name: [null] }),
      clientName: [],
      startBilling: [],
      startBillingRangeStart: [],
      startBillingRangeEnd: [],
      price: [null],
      endBilling: [],
      endBillingRangeStart: [],
      endBillingRangeEnd: [],
      deliveryDate: [],
      deliveryDateRangeStart: [],
      deliveryDateRangeEnd: [],
      contractName: [],
      service: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
    });
  }

  getCompany(): FormGroup {
      return this.fb.group({
        address: this.getAddress(),
        general: this.fb.group({
          name: [null, Validators.required],
          vat: [null, Validators.required],
          active: [null],
          language:   this.fb.group({ id: [null, Validators.required], name: [null] }),
        }),
        misc: this.fb.group({
           byForm: this.fb.group({
            updatedBy: [null],
            createdBy: [null]
          }),
        }),
        contact: this.getFormsService.getContact(),
        billing: this.fb.group({
          LogisticsIdentifier: [null, Validators.required],
          sapCode: [null],
          office: this.fb.group({ id: [null, Validators.required], name: [null] }),
          salesId: this.fb.group({ id: [null], name: [null] }),
          blocked: [null],
          groupBySite: [null],
        }),
        uuid: [null],
        created: [null],
        updated: [null],
        id: [null],
        displayName: [null],
      })
  }
  getAddress(): FormGroup {
    return this.fb.group({
      checkBox: [true],
      city: [null, Validators.required],
      countryForm: this.fb.group({
        name: [null, Validators.required],
      }),
      country: [null],
      created: [null],
      createdBy: [null],
      id: [null],
      line1: [null, Validators.required],
      line2: [null],
      line3: [null],
      name: [null],
      state: [null],
      updated: [null],
      updatedBy: [null],
      uuid: [null],
      zip: [null, Validators.required],
    });
  }


}


